<div class="grid grid-cols-3 gap-2">
    <lib-autocomplete
        [field]="autocompleteFieldConfig"
        [form]="form()"
        [errorStateMatcher]="phoneErrorStateMatcher"
        [showWarningState]="getShouldShowCountryCodeWarning()"
        [hint]="getWarningMessage()"
        [className]="getShouldShowCountryCodeWarning() ? 'field-warning' : ''"
        [icon]="getIconName()"
    />
    <lib-input-field
        i18n-label
        key="number"
        label="Mobile"
        class="lg:col-span-2 col-span-6"
        [form]="form()"
        [onBlur]="this.onPhoneInputBlur"
        [errorStateMatcher]="phoneErrorStateMatcher"
        [onFinishEditKeyPress]="this.onPhoneInputBlur"
    />
    <div class="h-2 col-span-3">
        @if (this.getErrorMessage()) {
            <mat-error class="phone-error" i18n>{{ this.getErrorMessage() }}</mat-error>
        }
    </div>
</div>
